import styled from 'styled-components';

export default styled.p`
color: red;
`;
